<template>
  <nut-popup visible position="bottom" :z-index="3" round style="overflow: hidden">
    <a-flex vertical gap="middle" justify="space-between" class="pop">
      <a-flex class="top">
        <scroll-list :list="Array.from({length:6}, (_, i) => i)" direction="top" :section-length="1" interval="3s">
          <template #item="{item}">
            <view class="item" :class="(item as number)%2==0 ? 'red' : 'green'">
              <span>优惠马上结束{{ item }}</span>
            </view>
          </template>
        </scroll-list>
        <close/>
      </a-flex>
      <a-flex vertical justify="space-between" class="header">
        <a-flex class="alert" align="flex-end">
          <text class="t1">大促优惠</text>
          <text class="desc">官方大促 限时直降</text>
        </a-flex>
        <a-flex class="product" gap="small">
          <nut-image :src="products[info.idx].thumbnail+'-sq.110'"/>
          <a-flex vertical gap="small" class="info">
            <view class="t1">
              <!--              大促价-->
              最后3小时¥{{ products[info.idx].price }}
              <view class="t1-sub">优惠前¥{{ products[info.idx].origin_price }}</view>
            </view>
            <view>
              <nut-tag plain type="danger">即将恢复{{ products[info.idx].origin_price }}元</nut-tag>
            </view>
            <view class="t2">
              <text>已选：{{ products[info.idx].name }}</text>
            </view>
            <view class="t3">同类畅销榜第1</view>
          </a-flex>
        </a-flex>
        <a-flex vertical gap="small" class="coupons">

        </a-flex>
      </a-flex>
      <a-flex gap="middle" justify="space-between" align="center" class="coupons">
        <text>优惠券</text>
        <view class="content">
          预热-22元，团长-22元
          <view class="bracket">(</view>

          <svg class="icon-clock" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3862"
               width="200" height="200">
            <path
                d="M512.238933 185.105067c-189.781333 0-343.722667 154.282667-343.722666 343.722666 0 189.44 153.941333 343.381333 343.722666 343.381334 189.44 0 343.381333-153.941333 343.381334-343.381334 0-189.44-153.941333-343.722667-343.381334-343.722666z m117.077334 377.856h-117.418667c-18.773333 0-34.133333-15.36-34.133333-34.133334v-177.152c0-18.773333 15.36-34.133333 34.133333-34.133333 19.114667 0 34.133333 15.36 34.133333 34.133333v143.018667h83.285334c19.114667 0 34.133333 15.36 34.133333 34.133333s-15.018667 34.133333-34.133333 34.133334zM863.3344 313.890133l-103.799467-103.8336a34.133333 34.133333 0 1 1 48.264534-48.264533l103.799466 103.8336a34.133333 34.133333 0 1 1-48.264533 48.264533zM112.401067 313.890133a34.133333 34.133333 0 0 1 0-48.264533L216.200533 161.792a34.133333 34.133333 0 1 1 48.264534 48.264533L160.6656 313.890133a34.133333 34.133333 0 0 1-48.264533 0z"
                p-id="3863" fill="#ff0000"></path>
          </svg>
          <count-down-txt-css :end-time="Date.now() + 600 * 1000"/>
          <view class="bracket">)</view>
          <right/>
        </view>
      </a-flex>

      <a-flex vertical class="content">
        <view class="item">
          <text class="label">门店</text>
          <view class="list">
            <view class="item on">
              <text>【无刷电机顶配款】金属滤芯13件套/永磁暴吸
                <text class="price">￥56.02</text>
              </text>
            </view>
            <view class="item">
              <text>北京
                <text class="price">￥56.02</text>
              </text>
            </view>
            <view class="item">
              <text>北京</text>
            </view>
          </view>
        </view>
        <view class="item">
          <text class="label">门店</text>
          <view class="list">
            <view class="item">
              <text>【无刷电机顶配款】金属滤芯13件套/永磁暴吸
                <text class="price">￥56.02</text>
              </text>
            </view>
            <view class="item">
              <text>北京
                <text class="price">￥56.02</text>
              </text>
            </view>
            <view class="item">
              <text>北京</text>
            </view>
          </view>
        </view>
        <view class="item">
          <text class="label">门店</text>
          <view class="list">
            <view class="item">
              <text>【无刷电机顶配款】金属滤芯13件套/永磁暴吸
                <text class="price">￥56.02</text>
              </text>
            </view>
            <view class="item">
              <text>北京
                <text class="price">￥56.02</text>
              </text>
            </view>
            <view class="item">
              <text>北京</text>
            </view>
          </view>
        </view>
      </a-flex>
      <nut-button class="pay-btn" type="primary" block>
        <view class="pay-btn-txt">
          现在抢，仅
          <view class="half">¥</view>
          34
          <view class="half">.34</view>
          <view class="del">¥{{ products[info.idx].origin_price }}</view>
        </view>
      </nut-button>
    </a-flex>
  </nut-popup>
</template>

<script setup lang="ts">

import {useRoute} from "vue-router";
import {AEditor} from "@/views/editor/service/editor";
import {computed, reactive} from "vue";
import {Close, Right} from '@nutui/icons-vue'
import ScrollList from "@/views/editor/section/lib/ScrollList.vue";
import CountDownTxtCss from "@/views/editor/components/display/CountDownTxtCss.vue";

const editor = useRoute().meta.editor as AEditor;
const promotion = editor.biz.active.promotion
const products = computed(() => promotion?.products() ?? [])
const info = reactive({idx: 0})
console.log('...............................')
</script>

<style scoped lang="sass">
.pop
  max-height: 566px
  min-height: 130px
  color: rgb(58, 58, 58)
  padding-bottom: 22px

  > .top
    display: block
    height: 44px
    overflow: hidden
    position: relative
    flex-shrink: 0

    > .nut-icon-close
      position: absolute
      right: 18px
      top: 50%
      bottom: 50%
      transform: translateY(-50%)
      height: 14px
      width: 14px
      color: #969799

    .item
      display: block
      font-size: 18px
      height: 44px
      line-height: 44px
      text-align: center

      &.green
        overflow: hidden
        background: radial-gradient(circle at center 30%, #f0fbf2 0%, #e6f7e9 100%)
        color: rgb(37, 181, 19)

      &.red
        overflow: hidden
        background: radial-gradient(circle at center 30%, #ffe4e4 0%, #ffeded 100%)
        color: rgb(224, 46, 36)


  > .header
    padding: 0 12px
    overflow: hidden
    flex-shrink: 0

    &:not(:has(>.alert))
      border-bottom: 1px solid rgb(242, 242, 242)

    > .alert
      border-radius: 8px
      background-color: red
      color: white
      padding: 2px 12px
      border-bottom: 12px solid red

      > .t1
        font-family: 'zh108', Arial, sans-serif
        font-size: 20px
        position: relative
        padding-right: 8px

        &:after
          content: ''
          position: absolute
          top: 6px
          right: 0
          bottom: 2px
          width: 1px
          background-color: #f0fbf2

      > .desc
        padding-left: 8px
        font-size: 14px
        line-height: 20px


      & + .product
        border-color: red

    > .product
      background-color: white
      border-radius: 8px
      border: 4px solid white
      padding: 6px
      margin-top: -12px

      > .nut-image
        background-color: white
        width: 100px
        height: 100px
        border-radius: 6px
        box-shadow: 0 0 0 3px #f2f2f2
        overflow: hidden
        flex-shrink: 0

      > .info
        overflow: hidden

        > .t1
          font-size: 18px
          color: red

          > .t1-sub
            color: rgb(88, 89, 91)
            font-size: 12px
            padding-left: 6px

        > .t2
          display: block
          font-size: 14px
          color: rgb(88, 89, 91)

          > text
            flex: 1
            display: block
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap

        > .t3
          font-size: 14px
          color: red


  > .coupons
    flex-shrink: 0
    margin-left: 12px
    padding: 0 0 12px 0
    border-bottom: 1px solid rgb(242, 242, 242)

    > text
      flex-shrink: 0
      font-size: 16px
      color: rgb(21, 21, 22)

    > .content
      display: inline-flex
      align-items: center
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
      color: rgb(224, 46, 36)
      font-weight: 500
      font-size: 15px

      > .icon-clock
        width: 18px
        height: 18px

      > .nut-countdown
        display: inline-block
        width: 85px

      > .nut-icon-right
        margin-right: 12px
        color: rgb(102, 102, 102)
        font-size: 15px
        width: 10px
        height: 10px

      > .bracket
        position: relative
        top: -2px
        padding: 0 2px


  > .content
    overflow-y: scroll
    flex: 1
    margin-top: -16px

    &::-webkit-scrollbar
      display: none

    > .item
      display: block
      padding: 14px 0 2px 12px

      > .label
        color: #151516
        display: block
        font-size: 16px
        line-height: 1
        text-align: left

      > .list
        display: block
        height: auto
        margin-top: 9px
        padding-right: 2px
        position: relative
        width: 100%

        > .item
          display: inline-block
          font-weight: 500
          text-overflow: ellipsis
          font-size: 15px
          padding: 5px 10px
          border-radius: 4px
          margin: 0 10px 10px 0
          flex: 1
          max-width: 100%
          background-color: #f5f5f5
          color: #151516
          border: 1px solid transparent

          .price
            color: #9c9c9c
            margin-right: 6px
            word-break: normal

          &.on
            background: rgba(224, 46, 36, .08)
            border: 1px solid #e02e24
            color: #e02e24

  > .pay-btn
    .pay-btn-txt
      font-size: 18px
      display: inline-flex
      align-items: baseline

      > .half
        font-size: 12px
        display: inline-block

      > .del
        color: rgba(255, 255, 255, 0.7)
        text-decoration: line-through
        padding-left: 7px

@font-face
  font-family: "zh108"
  //src: url("https://static.pms.guandb.cn/media/material/font/尔雅柳叶黑.ttf") format("truetype")
  src: url("https://static.pms.guandb.cn/media/material/font/字魂181号-飞驰标题体.ttf") format("truetype")

</style>